// Planes y precios de venta, en dólares (US$). Fuente: docs/estrategia/PLANES_Y_PRECIOS_PROPUESTA.md §10 (confirmado por el dueño el 2026-10-03).
// Los cambios de precio se hacen aquí: la página de precios lee todo de este archivo.

export const ANNUAL_DISCOUNT = 0.2;

export const PRICING_LINES = [
  {
    id: 'agenda',
    name: 'Agenda Inteligente',
    audience: 'Barberías, salones, spas, clínicas, consultorios y profesionales',
    plans: [
      {
        id: 'emprendedor', name: 'Emprendedor', badge: 'Para iniciar con IA', priceMonthly: 29, highlight: false,
        conversations: '600 conversaciones de IA al mes', scale: '1 profesional',
        features: ['Asistente Keyla con IA en tu WhatsApp, 24 horas', 'El bot te pregunta lo que no sabe y aprende', 'Agenda inteligente con Google Calendar', 'Recordatorios y confirmaciones de cita', 'Panel en el celular (PWA)'],
        notIncluded: ['Equipo, comisiones y finanzas', 'Multisede']
      },
      {
        id: 'pro', name: 'PRO', badge: 'MÁS POPULAR', priceMonthly: 59, highlight: true,
        conversations: '2.400 conversaciones de IA al mes', scale: 'Hasta 5 profesionales',
        features: ['Todo lo del plan Emprendedor', 'Equipo y comisiones por profesional', 'Finanzas y reportes', 'Reporte semanal por WhatsApp y análisis de competencia', 'Soporte prioritario por WhatsApp'],
        notIncluded: ['Multisede']
      },
      {
        id: 'avanzado', name: 'Avanzado', badge: 'Para crecer', priceMonthly: 99, highlight: false,
        conversations: '4.000 conversaciones de IA al mes (uso justo)', scale: 'Profesionales y agendas ilimitados',
        features: ['Todo lo del plan PRO', 'Multisede', 'Acompañamiento de puesta en marcha', 'Soporte prioritario'],
        notIncluded: []
      }
    ]
  },
  {
    id: 'pedidos',
    name: 'Pedidos y Ventas',
    audience: 'Restaurantes, comida rápida, tiendas, repostería y domicilios',
    plans: [
      {
        id: 'emprendedor', name: 'Emprendedor', badge: 'Para iniciar con IA', priceMonthly: 35, highlight: false,
        conversations: '300 conversaciones de IA al mes', scale: '1 sede',
        features: ['Asistente Keyla con IA que toma pedidos por WhatsApp, 24 horas', 'El bot te pregunta lo que no sabe y aprende', 'Catálogo de productos y precios', 'Calculadora de domicilios', 'Panel en el celular (PWA)'],
        notIncluded: ['Menú en PDF y fotos', 'Inventario, caja y finanzas']
      },
      {
        id: 'pro', name: 'PRO', badge: 'MÁS POPULAR', priceMonthly: 69, highlight: true,
        conversations: '1.200 conversaciones de IA al mes', scale: '1 sede',
        features: ['Todo lo del plan Emprendedor', 'Menú multimedia: el bot envía tu PDF y tus fotos', 'Inventario, caja y finanzas', 'Reporte semanal por WhatsApp y análisis de competencia', 'Soporte prioritario por WhatsApp'],
        notIncluded: ['Multisede']
      },
      {
        id: 'avanzado', name: 'Avanzado', badge: 'Para crecer', priceMonthly: 119, highlight: false,
        conversations: '2.400 conversaciones de IA al mes (uso justo)', scale: 'Sedes ilimitadas',
        features: ['Todo lo del plan PRO', 'Monitor de cocina y caja', 'Multisede', 'Acompañamiento de puesta en marcha'],
        notIncluded: []
      }
    ]
  }
];

// Complementos que se pueden sumar a un plan (precio por mes). Prospección Maps no se muestra: sigue en prueba interna.
export const PRICING_ADDONS = [
  { id: 'campanas', name: 'Campañas de WhatsApp', price: 15, note: 'Desde el plan PRO' },
  { id: 'fidelizacion', name: 'Fidelización y cupones', price: 9, note: 'Desde el plan PRO' },
  { id: 'numero', name: 'Número de WhatsApp adicional', price: 9, note: 'Todos los planes' },
  { id: 'paquete-agenda', name: '+500 conversaciones (Agenda)', price: 12, note: 'Todos los planes' },
  { id: 'paquete-pedidos', name: '+300 conversaciones (Pedidos)', price: 15, note: 'Todos los planes' },
  { id: 'profesional', name: 'Profesional adicional (Agenda)', price: 6, note: 'Planes Emprendedor y PRO' }
];

// Precio por mes con el descuento anual, redondeado a centavos.
export const annualMonthly = (priceMonthly) => Math.round(priceMonthly * (1 - ANNUAL_DISCOUNT) * 100) / 100;

// "US$29" o "US$23,20" (coma decimal, como se escribe en Colombia).
export const formatUsd = (value) => {
  const n = Number(value);
  const text = Number.isInteger(n) ? String(n) : n.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `US$${text}`;
};
